import React from 'react'

import { Helmet } from 'react-helmet'

import Navigation from '../components/navigation'
import Footer from '../components/footer'
import './homepage.css'

const Homepage = (props) => {
  return (
    <div className="homepage-container">
      <Helmet>
        <title>Bounce Houses & Event Rentals | BounceHouseKatie.com</title>
        <meta
          name="description"
          content="Rent bounce houses, slides, inflatables, tables, chairs, and party décor for your event. Browse our full collection and book today."
        />
        <meta
          property="og:title"
          content="Bounce Houses &amp; Event Rentals | BounceHouseKatie.com"
        />
        <meta
          property="og:description"
          content="Rent bounce houses, slides, inflatables, tables, chairs, and party décor for your event. Browse our full collection and book today."
        />
        <meta
          property="og:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/29bbbe6f-6c7b-4302-8334-95a267bd019b/f1e9c444-a5c4-4c2d-bfe3-0d9fba754bc4?org_if_sml=1&amp;force_format=original"
        />
        <meta property="og:type" content="website" />
        <meta
          name="twitter:title"
          content="Bounce Houses &amp; Event Rentals | BounceHouseKatie.com"
        />
        <meta
          name="twitter:description"
          content="Rent bounce houses, slides, inflatables, tables, chairs, and party décor for your event. Browse our full collection and book today."
        />
        <meta
          name="twitter:image"
          content="https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/29bbbe6f-6c7b-4302-8334-95a267bd019b/f1e9c444-a5c4-4c2d-bfe3-0d9fba754bc4?org_if_sml=1&amp;force_format=original"
        />
        <link
          rel="canonical"
          href="https://sudden-pleasant-manatee-mevyzg.teleporthq.site/"
        />
        <meta
          property="og:url"
          content="https://sudden-pleasant-manatee-mevyzg.teleporthq.site/"
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"Organization","name":"Event Rentals | Bounce Houses, Tables & More","url":"https://sudden-pleasant-manatee-mevyzg.teleporthq.site","logo":"https://aheioqhobo.cloudimg.io/v7/_playground-bucket-v2.teleporthq.io_/29bbbe6f-6c7b-4302-8334-95a267bd019b/f1e9c444-a5c4-4c2d-bfe3-0d9fba754bc4?org_if_sml=1&force_format=original"}',
          }}
        />
        <script
          type="application/ld+json"
          dangerouslySetInnerHTML={{
            __html:
              '{"@context":"https://schema.org","@type":"WebSite","name":"Event Rentals | Bounce Houses, Tables & More","url":"https://sudden-pleasant-manatee-mevyzg.teleporthq.site","description":"Full-service event rentals including bounce houses, slides, inflatables, tables, chairs, concessions, and décor for celebrations and gatherings."}',
          }}
        />
      </Helmet>
      <Navigation></Navigation>
      <main id="tq-main" className="bh-home-main">
        <section id="book" className="bh-home-hero">
          <div className="bh-hero-inner">
            <div className="bh-hero-copy">
              <p className="bh-hero-eyebrow">
                <span>
                  CALL
                  <span
                    dangerouslySetInnerHTML={{
                      __html: ' ',
                    }}
                  />
                </span>
                <a href="tel:954-471-5525" className="homepage-link">
                  954-471-5525
                </a>
              </p>
              <h1 className="bh-hero-title">
                <span className="homepage-text2">Bounce</span>
                <br className="homepage-text3"></br>
                <span className="homepage-text4">           House</span>
                <br className="homepage-text5"></br>
                <span className="homepage-text6">
                                         Katie
                </span>
                <span>!</span>
              </h1>
              <p className="bh-hero-text">
                Bounce houses, slides, tents, treats, and more; delivered with
                care for unforgettable birthdays, school celebrations, and
                family gatherings.
              </p>
              <div className="homepage-thq-bh-hero-actions-elm bh-hero-actions"></div>
            </div>
            <div className="bh-hero-media">
              <img
                loading="eager"
                decoding="async"
                alt="Children enjoying an inflatable water slide at an outdoor party"
                src="/ai-generated/ai-generated-1789014143710-1500h.png"
                className="bh-hero-image"
              />
            </div>
          </div>
        </section>
        <section id="rental-gallery" className="bh-gallery-section">
          <div className="bh-gallery-intro">
            <h2 className="bh-gallery-title">Rentals and Services</h2>
            <p className="bh-gallery-text">
              Browse the showcases below; and call or text 954-471-5525 to
              discuss availability and receive photos of what we have!
            </p>
          </div>
          <div className="bh-category-grid">
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Colorful bounce house set up for a children's party"
                src="/ai-generated/ai-generated-1789014848621-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Bounce Houses</h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Inflatable combo moonwalk and slide for a party"
                src="/ai-generated/ai-generated-1789014861314-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">
                  Combo; Moonwalk &amp; Slide
                </h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Large inflatable water slide at an outdoor event"
                src="/ai-generated/ai-generated-1789014868467-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Big Water Slides</h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Metal and resin frame chairs arranged for an event"
                src="/ai-generated/ai-generated-1789014868249-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">
                  Metal &amp; Resin Frame Chairs
                </h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Wooden marquee letters displayed for a celebration"
                src="/ai-generated/ai-generated-1789014866247-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Wooden Marquee Letters</h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Concession machine ready for a party rental"
                src="/ai-generated/ai-generated-1789014872796-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Concession Machines</h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Pony and petting zoo experience at an outdoor party"
                src="/ai-generated/ai-generated-1789014870409-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Ponies &amp; Petting Zoo</h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Trackless train ready for children at an event"
                src="/ai-generated/ai-generated-1789014871846-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Trackless Train</h3>
              </div>
            </article>
            <article className="bh-category-tile">
              <img
                loading="lazy"
                decoding="async"
                alt="Outdoor canopy tent set up for a celebration"
                src="/ai-generated/ai-generated-1789014871723-1500h.png"
                className="bh-category-image"
              />
              <div className="bh-category-overlay">
                <h3 className="bh-category-name">Canopies &amp; Tents</h3>
              </div>
            </article>
          </div>
        </section>
      </main>
      <Footer></Footer>
    </div>
  )
}

export default Homepage
